/*
 * @Author: wq
 * @Date: 2020-07-14 10:01:56
 */

import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
// 修复重复点击菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      component: () => import("@/pages/indexPages/index"),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/test",
      name: "Test",
      component: () => import("@/pages/testPages/index")
    },
    {
      path: "/tender",
      name: "Tender",
      component: () => import("@/pages/overTenderPages/index"),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/tenderdetails",
      name: "TenderDetails",
      component: () => import("@/pages/overTenderPages/tenderDetails")
    },
    {
      path: "/tenderCalendar",
      name: "TenderCalendar",
      component: () => import("@/pages/overTenderPages/tenderCalendar")
    },
    {
      path: "/winning",
      name: "Winning",
      component: () => import("@/pages/winningPages/index"),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/diningHall",
      name: "DiningHall",
      component: () => import("@/pages/diningHallOpenPages/index"),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/diningHallDetail",
      name: "DiningHallDetail",
      component: () => import("@/pages/diningHallOpenPages/diningHallDetail"),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/cleanDishPages", // 光盘行动首页
      name: "CleanDishPages",
      component: () => import("@/pages/cleanDishPages/index")
    },
    {
      path: "/volationWarning", // 违规预警首页
      name: "VolationWarning",
      component: () => import("@/pages/volationWarningPages/index")
    },
    {
      path: "/servicetron",
      name: "Servicetron",
      component: () => import("@/pages/servicetronPages/index"),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/servicedetails",
      name: "ServiceDetails",
      component: () => import("@/pages/servicetronPages/serviceDetails")
    },
    {
      path: "/complaint",
      name: "Complaint",
      component: () => import("@/pages/complaintPages/index"),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/school",
      name: "School",
      component: () => import("@/pages/check/school"),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/merchants",
      name: "Merchants",
      component: () => import("@/pages/check/merchants"),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/successPage",
      name: "SuccessPage",
      component: () => import("@/pages/check/successPage")
    },
    
    {
      path: "/exposure",
      name: "exposurePages",
      component: () => import("@/pages/exposurePages/index"),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/statute",
      name: "StatutePages",
      component: () => import("@/pages/statutePages/index"),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/riskfood",
      name: "RiskFood",
      component: () => import("@/pages/riskFood/index"),
      meta: {
        keepAlive: true // 需要被缓存
      }
    },
    {
      path: "/system",
      name: "SystemNotice",
      component: () => import("@/pages/systemNoticePages/index")
    },
    {
      path: "/warningDetai",
      name: "warningDetai",
      component: () => import("@/pages/indexPages/warningDetai")
    }
    
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js